// extracted by mini-css-extract-plugin
export default {"container":"qq-z","ratingLayout":"rq-z","ratingLabel":"sq-z","nonInteractiveRatingLabel":"tq-z"};